module.exports = __webpack_public_path__ + "img/hanging.5a243722.svg";